function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import * as React from 'react';
import { Grid, Image } from 'semantic-ui-react';
import InlineSVG from './components/InlineSvg';
import rmrLogo from '../src/assets/images/logos/rmr_logo_0,25x.png';
import '../src/assets/css/index.css';

var Footer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Footer, _React$Component);

  function Footer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Footer.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        socialMedia = _this$props.socialMedia,
        contactUsLink = _this$props.contactUsLink,
        privacyPolicyLink = _this$props.privacyPolicyLink,
        refundPolicyLink = _this$props.refundPolicyLink,
        termsAndConditionsLink = _this$props.termsAndConditionsLink;
    var linkedInUrl = 'http://www.linkedin.com/company/roymorganaus';
    var twitterUrl = 'https://twitter.com/roymorganaus';
    var instagramUrl = 'https://www.instagram.com/roymorganaus/';
    var facebookUrl = 'https://www.facebook.com/roymorganaus';
    var youTubeUrl = 'https://www.youtube.com/c/roymorganaus';
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "page-footer-container"
    }, /*#__PURE__*/React.createElement("footer", {
      className: "page-footer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "page-footer__top-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "page-footer__social-links"
    }, /*#__PURE__*/React.createElement("a", {
      href: linkedInUrl,
      target: "_blank"
    }, /*#__PURE__*/React.createElement(InlineSVG, {
      name: "linkedin",
      colour: "dark-grey",
      className: "page-footer__social-link-icon page-footer__social-link-icon--square"
    })), /*#__PURE__*/React.createElement("a", {
      href: twitterUrl,
      target: "_blank"
    }, /*#__PURE__*/React.createElement(InlineSVG, {
      name: "twitter",
      colour: "dark-grey",
      className: "page-footer__social-link-icon page-footer__social-link-icon--square"
    })), /*#__PURE__*/React.createElement("a", {
      href: instagramUrl,
      target: "_blank"
    }, /*#__PURE__*/React.createElement(InlineSVG, {
      name: "instagram",
      colour: "dark-grey",
      className: "page-footer__social-link-icon page-footer__social-link-icon--square"
    })), /*#__PURE__*/React.createElement("a", {
      href: facebookUrl,
      target: "_blank"
    }, /*#__PURE__*/React.createElement(InlineSVG, {
      name: "facebook",
      colour: "dark-grey",
      className: "page-footer__social-link-icon page-footer__social-link-icon--square"
    })), /*#__PURE__*/React.createElement("a", {
      href: youTubeUrl,
      target: "_blank"
    }, /*#__PURE__*/React.createElement(InlineSVG, {
      name: "youtube",
      colour: "dark-grey",
      className: "page-footer__social-link-icon page-footer__social-link-icon--square"
    }))), /*#__PURE__*/React.createElement("div", {
      className: contactUsLink && privacyPolicyLink && termsAndConditionsLink && termsAndConditionsLink ? 'page-footer__links all-links' : 'page-footer__links'
    }, /*#__PURE__*/React.createElement("a", {
      href: contactUsLink ? contactUsLink : 'https://live.roymorgan.com/contact-us'
    }, "Contact"), /*#__PURE__*/React.createElement("a", {
      href: privacyPolicyLink ? privacyPolicyLink : 'https://live.roymorgan.com/privacy-policy'
    }, "Privacy Policy"), termsAndConditionsLink && /*#__PURE__*/React.createElement("a", {
      href: termsAndConditionsLink
    }, "Terms and Conditions"), refundPolicyLink && /*#__PURE__*/React.createElement("a", {
      href: refundPolicyLink
    }, "Refund Policy")), /*#__PURE__*/React.createElement("div", {
      className: "page-footer__logo-container"
    }, /*#__PURE__*/React.createElement("a", {
      href: "http://roymorgan.com",
      target: "_blank"
    }, /*#__PURE__*/React.createElement("img", {
      className: "page-footer__logo",
      src: this.props.footerLogo ? this.props.footerLogo : rmrLogo,
      alt: "Roy Morgan"
    })))), /*#__PURE__*/React.createElement(Grid, {
      className: "page-footer__addresses"
    }, /*#__PURE__*/React.createElement(Grid.Column, {
      tablet: 4,
      computer: 2
    }, /*#__PURE__*/React.createElement("h5", null, "Melbourne"), /*#__PURE__*/React.createElement("p", null, "Tonic House", /*#__PURE__*/React.createElement("br", null), "386 Flinders Lane,", /*#__PURE__*/React.createElement("br", null), "Melbourne VIC, 3000")), /*#__PURE__*/React.createElement(Grid.Column, {
      tablet: 4,
      computer: 2
    }, /*#__PURE__*/React.createElement("h5", null, "Sydney"), /*#__PURE__*/React.createElement("p", null, "484 Kent Street,", /*#__PURE__*/React.createElement("br", null), "Sydney, NSW, 2000"))))));
  };

  return Footer;
}(React.Component);

export default Footer;